<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="row m-0 col-12 pb-3 bg-white border-r-16 pt-4">
          <div class="col-md-4 p-0">
            <span class="leatext_job_heading_by_new_home">Advertised jobs</span>
          </div>
          <div
            class="
              col-md-8
              p-0
              row
              m-0
              d-flex
              justify-content-end
              new_list_st_by_ch
            "
          >
            <div class="col-lg-5 p-0 filter_by_ch">
              <v-combobox
                v-model="job_title_filter"
                class="b_form_slecet_search_save11"
                style="width: 300px; max-width: 300px; min-width: 300px"
                :items="jobs"
                label="Filter by Job vacancy"
                @change="
                  (e) => {
                    myFunc(e);
                  }
                "
              >
                <template>
                  <v-chip
                    :key="JSON.stringify(data.item)"
                    v-bind="data.attrs"
                    :input-value="data.selected"
                    :disabled="data.disabled"
                    @click:close="data.parent.selectItem(data.item)"
                  >
                    {{ data.item }}
                  </v-chip>
                </template>
              </v-combobox>
            </div>
            <div class="col-lg-3 p-0">
              <button
                type="button"
                class="custom-add-new-record-button btn_dash_ch___ mr-2"
                fab
                small
                @click="createFormEnable"
              >
                Add new Job
              </button>
            </div>
          </div>
        </div>
        <div class="col-md-12 row p-0 m-0">
          <!-- /////////////////////////////////// -->
          <div data-app class="p-0">
            <div class="row mt-1 mx-0 new_list_st_by_ch">
              <div class="row m-0 col-8 py-0 pl-0" style="height: fit-content">
                <!-- //////////////////////////////////start -->
                <!-- for fillter .filter((item) => item.user) -->
                <div
                  class="empty_div_jobsAdd"
                  v-if="
                    data.filter(
                      (item) => item.archive == '0' && item.draft == '0'
                    ).length == 0
                  "
                >
                  You don't have any job posted.
                </div>
                <div
                  class="col-md-4 row m-0 mt-4 pt-0 pr-0"
                  v-for="(item, index) in data.filter(
                    (item) => item.archive == '0' && item.draft == '0'
                  )"
                  :key="index"
                  :class="index == 0 || index % 3 == 0 ? 'pl-0' : ''"
                >
                  <div
                    class="col-md-12 row m-0 border-r-16 p-4"
                    :class="
                      detail1 && detail1.id === item.id
                        ? 'bg-info-new'
                        : 'bg-white'
                    "
                  >
                    <div class="col-md-12 p-0">
                      <h4
                        class="mb-0"
                        style="
                          color: #242424;
                          font-size: 18px;
                          font-weight: bold;
                        "
                      >
                        {{ item.job_title }}
                      </h4>
                    </div>
                    
                    <div class="col-md-12 p-0">
                      <div class="m-0" style="color: #666; font-size: 14px">
                        <h4
                          class="
                            widget-title
                            tooltipch
                            mb-0
                            mt-3
                            bold
                            detail_heading
                          "
                        >
                          <img
                            src="/images/job_page/Location_left.svg"
                            alt="..."
                            class="pr-4"
                          /><span class="tooltiptextch">Job Location</span>
                        </h4>
                        <p
                          v-if="item.location_city"
                          class="col col-md-3 text-primary mb-0 detail_body"
                          style="display: contents"
                        >
                          <span
                            v-for="(_item, _index) in item &&
                            item.location_city"
                            :key="_index"
                            style="display: inline-flex"
                          >
                            <span
                              v-if="
                                _index > 0 && _index < item.location_city.length
                              "
                              style=""
                              >&nbsp;,&nbsp;</span
                            >
                            {{ _item }}
                          </span>
                          <span v-if="item.location_city == ''">Not add</span>
                        </p>
                        <!-- </div> -->
                      </div>
                    </div>
                    <div class="col-md-12 p-0 py-2">
                      <div class="m-0" style="color: #666; font-size: 14px">
                        <h4
                          class="
                            widget-title
                            tooltipch
                            mb-0
                            bold
                            detail_heading
                          "
                        >
                          <img
                            src="/images/job_page/Money_left.svg"
                            alt="..."
                            class="pr-2"
                          /><span class="tooltiptextch">Per month salary</span>
                        </h4>
                        <span
                          v-if="
                            item.salary_min != NULL &&
                            item.salary_market_competitive != 1 &&
                            item.salary_depends_on_exp != 1
                          "
                          >{{ item.salary_min }} - {{ item.salary_max }}</span
                        >
                        <span v-if="item.salary_market_competitive == 1">
                          Salary market competitive</span
                        >
                        <span v-if="item.salary_depends_on_exp == 1">
                          Salary depends on exp</span
                        >
                        <span
                          v-if="
                            item.salary_min == NULL &&
                            item.salary_market_competitive != 1 &&
                            item.salary_depends_on_exp != 1
                          "
                        >
                          Not add</span
                        >
                      </div>
                    </div>
                    <div class="col-md-12 p-0 pb-2">
                      <div class="m-0" style="color: #666; font-size: 14px">
                        <h4
                          class="
                            widget-title
                            tooltipch
                            mb-0
                            bold
                            detail_heading
                          "
                        >
                          <img
                            src="/images/job_page/Due_date.svg"
                            alt="..."
                            class="pr-4"
                          /><span class="tooltiptextch">Expiry Date</span>
                        </h4>
                        <span>{{
                          moment(item.apply_by).format("DD MMM, YYYY")
                        }}</span>
                      </div>
                    </div>
                    <div class="_btn_gridddd_add_jon _btn_gridddd p-0 m-0">
                      <div class="p-0" @click="singleDetail1(item)">
                        <button
                          type="button"
                          class="new_details_job_dashbord_list2 back_fill_job"
                        >
                          view Job Details
                        </button>
                      </div>
                      <div class="p-0" style="">
                        <button
                          type="button"
                          class="new_details_job_dashbord_list2"
                        >
                          <div
                            @contextmenu="handler($event)"
                            @click="editButtonClick(item.id)"
                          >
                            <span class="v-btn__content">Edit</span>
                          </div>
                        </button>
                      </div>
                      <div
                        class="p-0"
                        style="position: relative"
                        @click="jobArchive(item)"
                      >
                        <button
                          type="button"
                          class="
                            new_details_job_dashbord_list2
                            tooltipch
                            archive_buton
                          "
                        >
                          <img
                            class="dashbord"
                            src="\images/job_page/archive.png"
                            alt=""
                            width="16"
                            height="16"
                          />
                          <span class="tooltiptextch gray">Archive Job</span>
                        </button>
                      </div>
                    </div>
                    <div class="col-8 px-0 pt-4 m-0 info_short_leatesd">
                      <img
                        src="/images/job_application/InfoCircle.svg"
                        class=""
                      />
                      <span>
                        Added:
                        {{ moment(item.created_at).format("DD MMM, YYYY") }}
                      </span>
                    </div>
                    <div
                      class="col-4 px-0 pt-4 m-0 info_short_leatesd text-end"
                      v-if="!item.draft_behave"
                    >
                      <span
                        @click="deleteButtonClick(item)"
                        style="color: rgb(231 37 8); cursor: pointer"
                        >Delete job</span
                      >
                    </div>
                  </div>
                </div>
                <hr
                  class="col-md-12 p-0 mt-4"
                  style="background: rgba(53, 162, 229, 0.25)"
                />
                <div class="row m-0 col-12 pb-3 bg-white border-r-16 pt-4">
                  <div class="col-md-4 p-0">
                    <span class="leatext_job_heading_by_new_home"
                      >Draft jobs</span
                    >
                  </div>
                  <div
                    class="
                      col-md-8
                      p-0
                      row
                      m-0
                      d-flex
                      justify-content-end
                      new_list_st_by_ch
                    "
                  ></div>
                </div>
                <div
                  class="empty_div_jobsAdd"
                  v-if="data.filter((item) => item.draft == '1').length == 0"
                >
                  You don't have any saved drafts
                </div>
                <div
                  class="col-md-4 row m-0 mt-4 pt-0 pr-0"
                  v-for="(item, index) in data.filter(
                    (item) => item.draft == '1'
                  )"
                  :key="index"
                  :class="index == 0 || index % 3 == 0 ? 'pl-0' : ''"
                >
                  <div
                    class="col-md-12 row m-0 border-r-16 p-4"
                    :class="
                      detail1 && detail1.id === item.id
                        ? 'bg-info-new'
                        : 'bg-white'
                    "
                  >
                    <div class="col-md-12 p-0">
                      <h4
                        class="mb-0"
                        style="
                          color: #242424;
                          font-size: 18px;
                          font-weight: bold;
                        "
                      >
                        {{ item.job_title }}
                      </h4>
                    </div>
                    <!-- <div class="col-md-12 p-0"> -->
                    <!-- <p
                        class=""
                        style="
                          width: fit-content;
                          border: 1px solid silver;
                          padding: 0px 2px 0px;
                          border-radius: 3px;
                          margin-right: 3px;
                          display: inline-block;
                          margin-bottom: 0 !important;
                          margin-top: 3px !important;
                        "
                        v-for="(_data, _index) in item.location_city"
                        :key="_index"
                        :class="_index > 4 ? 'd__none__' : ''"
                      >
                        {{ _data }}
                      </p> -->
                    <!-- </div> -->
                    <div class="col-md-12 p-0">
                      <div class="m-0" style="color: #666; font-size: 14px">
                        <h4
                          class="
                            widget-title
                            tooltipch
                            mb-0
                            mt-3
                            bold
                            detail_heading
                          "
                        >
                          <img
                            src="/images/job_page/Location_left.svg"
                            alt="..."
                            class="pr-4"
                          /><span class="tooltiptextch">Job Location</span>
                        </h4>
                        <p
                          v-if="item.location_city"
                          class="col col-md-3 text-primary mb-0 detail_body"
                          style="display: contents"
                        >
                          <span
                            v-for="(_item, _index) in item &&
                            item.location_city"
                            :key="_index"
                            style="display: inline-flex"
                          >
                            <span
                              v-if="
                                _index > 0 && _index < item.location_city.length
                              "
                              style=""
                              >&nbsp;,&nbsp;</span
                            >
                            {{ _item }}
                          </span>
                          <span v-if="item.location_city == ''">Not add</span>
                        </p>
                        <!-- </div> -->
                      </div>
                    </div>
                    <div class="col-md-12 p-0 py-2">
                      <div class="m-0" style="color: #666; font-size: 14px">
                        <h4
                          class="
                            widget-title
                            tooltipch
                            mb-0
                            bold
                            detail_heading
                          "
                        >
                          <img
                            src="/images/job_page/Money_left.svg"
                            alt="..."
                            class="pr-2"
                          /><span class="tooltiptextch">Per month salary</span>
                        </h4>
                        <span
                          v-if="
                            item.salary_min != NULL &&
                            item.salary_market_competitive != 1 &&
                            item.salary_depends_on_exp != 1
                          "
                          >{{ item.salary_min }} - {{ item.salary_max }}</span
                        >
                        <span v-if="item.salary_market_competitive == 1">
                          Salary market competitive</span
                        >
                        <span v-if="item.salary_depends_on_exp == 1">
                          Salary depends on exp</span
                        >
                        <span
                          v-if="
                            item.salary_min == NULL &&
                            item.salary_market_competitive != 1 &&
                            item.salary_depends_on_exp != 1
                          "
                        >
                          Not add</span
                        >
                      </div>
                    </div>
                    <div class="col-md-12 p-0 pb-2">
                      <div class="m-0" style="color: #666; font-size: 14px">
                        <h4
                          class="
                            widget-title
                            tooltipch
                            mb-0
                            bold
                            detail_heading
                          "
                        >
                          <img
                            src="/images/job_page/Due_date.svg"
                            alt="..."
                            class="pr-4"
                          /><span class="tooltiptextch">Expiry Date</span>
                        </h4>
                        <span>{{
                          moment(item.apply_by).format("DD MMM, YYYY")
                        }}</span>
                      </div>
                    </div>
                    <div class="_btn_gridddd_add_jon _btn_gridddd p-0 m-0">
                      <div class="p-0" @click="singleDetail1(item)">
                        <button
                          type="button"
                          class="new_details_job_dashbord_list2 back_fill_job"
                        >
                          view Job Details
                        </button>
                      </div>
                      <div class="p-0" style="">
                        <button
                          type="button"
                          class="new_details_job_dashbord_list2"
                        >
                          <div
                            @contextmenu="handler($event)"
                            @click="editButtonClick(item.id)"
                          >
                            <span class="v-btn__content">Edit</span>
                          </div>
                        </button>
                      </div>
                      <div
                        class="p-0"
                        style="position: relative"
                        @click="jobArchive(item)"
                      >
                        <button
                          type="button"
                          class="
                            new_details_job_dashbord_list2
                            tooltipch
                            archive_buton
                          "
                        >
                          <img
                            class="dashbord"
                            src="\images/job_page/archive.png"
                            alt=""
                            width="16"
                            height="16"
                          />
                          <span class="tooltiptextch gray">Archive Job</span>
                        </button>
                      </div>
                    </div>
                    <div class="col-8 px-0 pt-4 m-0 info_short_leatesd">
                      <img
                        src="/images/job_application/InfoCircle.svg"
                        class=""
                      />
                      <span>
                        Added:
                        {{ moment(item.created_at).format("DD MMM, YYYY") }}
                      </span>
                    </div>
                    
                    <div
                      class="col-4 px-0 pt-4 m-0 info_short_leatesd text-end"
                      v-if="!item.draft_behave"
                    >
                      <span
                        @click="deleteButtonClick(item)"
                        style="color: rgb(231 37 8); cursor: pointer"
                        >Delete job</span
                      >
                    </div>
                  </div>
                </div>
                <hr
                  class="col-md-12 p-0 mt-4"
                  style="background: rgba(53, 162, 229, 0.25)"
                />
                <div class="row m-0 col-12 pb-3 bg-white border-r-16 pt-4">
                  <div class="col-md-4 p-0">
                    <span class="leatext_job_heading_by_new_home"
                      >Archive jobs</span
                    >
                  </div>
                  <div
                    class="
                      col-md-8
                      p-0
                      row
                      m-0
                      d-flex
                      justify-content-end
                      new_list_st_by_ch
                    "
                  ></div>
                </div>
                <div
                  class="empty_div_jobsAdd"
                  v-if="data.filter(
                    (item) => item.archive == '1'
                  ).length === 0"
                >
                  You don't have any saved archive
                </div>
                <div
                  class="col-md-4 row m-0 mt-4 pt-0 pr-0"
                  v-for="(item, index) in data.filter(
                    (item) => item.archive == '1'
                  )"
                  :key="index"
                  :class="index == 0 || index % 3 == 0 ? 'pl-0' : ''"
                >
                  <div
                    class="col-md-12 row m-0 border-r-16 p-4"
                    :class="
                      detail1 && detail1.id === item.id
                        ? 'bg-info-new'
                        : 'archive_dark'
                    "
                  >
                    <div class="col-md-12 p-0">
                      <h4
                        class="mb-0"
                        style="
                          color: #242424;
                          font-size: 18px;
                          font-weight: bold;
                        "
                      >
                        {{ item.job_title }}
                      </h4>
                    </div>
                    <!-- <div class="col-md-12 p-0">
                      <p
                        class=""
                        style="
                          width: fit-content;
                          border: 1px solid silver;
                          padding: 0px 2px 0px;
                          border-radius: 3px;
                          margin-right: 3px;
                          display: inline-block;
                          margin-bottom: 0 !important;
                          margin-top: 3px !important;
                        "
                        v-for="(_data, _index) in item.location_city"
                        :key="_index"
                        :class="_index > 4 ? 'd__none__' : ''"
                      >
                        {{ _data }}
                      </p>
                    </div> -->

                    <div class="col-md-12 p-0">
                      <div class="m-0" style="color: #666; font-size: 14px">
                        <h4
                          class="
                            widget-title
                            tooltipch
                            mb-0
                            mt-3
                            bold
                            detail_heading
                          "
                        >
                          <img
                            src="/images/job_page/Location.svg"
                            alt="..."
                            class="pr-4"
                          /><span class="tooltiptextch">Job Location</span>
                        </h4>
                        <p
                          v-if="item.location_city"
                          class="col col-md-3 text-primary mb-0 detail_body"
                          style="display: contents"
                        >
                          <span
                            v-for="(_item, _index) in item &&
                            item.location_city"
                            :key="_index"
                            style="display: inline-flex; color: #605f5f"
                          >
                            <span
                              v-if="
                                _index > 0 && _index < item.location_city.length
                              "
                              style=""
                              >&nbsp;,&nbsp;</span
                            >
                            {{ _item }}
                          </span>
                        </p>
                        <!-- </div> -->
                      </div>
                    </div>
                    <div class="col-md-12 p-0 py-2">
                      <div class="m-0" style="color: #666; font-size: 14px">
                        <h4
                          class="
                            widget-title
                            tooltipch
                            mb-0
                            bold
                            detail_heading
                          "
                        >
                          <img
                            src="/images/job_page/Money.svg"
                            alt="..."
                            class="pr-2"
                          /><span class="tooltiptextch">Per month salary</span>
                        </h4>
                        <span
                          v-if="
                            item.salary_min != NULL &&
                            item.salary_market_competitive != 1 &&
                            item.salary_depends_on_exp != 1
                          "
                          >{{ item.salary_min }} - {{ item.salary_max }}</span
                        >
                        <span v-if="item.salary_market_competitive == 1">
                          Salary market competitive</span
                        >
                        <span v-if="item.salary_depends_on_exp == 1">
                          Salary depends on exp</span
                        >
                        <span
                          v-if="
                            item.salary_min == NULL &&
                            item.salary_market_competitive != 1 &&
                            item.salary_depends_on_exp != 1
                          "
                        >
                          Not add</span
                        >
                      </div>
                    </div>
                    <div class="col-md-12 p-0 pb-2">
                      <div class="m-0" style="color: #666; font-size: 14px">
                        <h4
                          class="
                            widget-title
                            tooltipch
                            mb-0
                            bold
                            detail_heading
                          "
                        >
                          <img
                            src="/images/job_page/dark_exp.svg"
                            alt="..."
                            class="pr-2"
                          /><span class="tooltiptextch">Expiry Date</span>
                        </h4>
                        <span>{{
                          moment(item.apply_by).format("DD MMM, YYYY")
                        }}</span>
                      </div>
                    </div>
                    <div class="_btn_gridddd_add_jon _btn_gridddd p-0 m-0">
                      <div class="p-0" @click="singleDetail1(item)">
                        <button
                          type="button"
                          class="
                            new_details_job_dashbord_list2
                            back_fill_job_dark
                          "
                        >
                          view Job Details
                        </button>
                      </div>
                      <div class="p-0" style="">
                        <button
                          type="button"
                          class="
                            new_details_job_dashbord_list2
                            new_details_job_dashbord_list2_dark
                          "
                        >
                          <div
                            @contextmenu="handler($event)"
                            @click="editButtonClick(item.id)"
                          >
                            <span class="v-btn__content">Edit</span>
                          </div>
                        </button>
                      </div>
                      <div
                        class="p-0"
                        style="position: relative"
                        @click="jobArchive(item)"
                      >
                        <button
                          type="button"
                          class="
                            new_details_job_dashbord_list2
                            tooltipch
                            archive_buton
                          "
                        >
                          <img
                            class="dashbord"
                            src="\images/job_page/unarchive.svg"
                            alt=""
                            width="16"
                            height="16"
                          />
                          <span class="tooltiptextch gray">Archive Job</span>
                        </button>
                      </div>
                    </div>
                    <div class="col-8 px-0 pt-4 m-0 info_short_leatesd">
                      <img
                        src="/images/job_application/InfoCircle.svg"
                        class=""
                      />
                      <span>
                        Added:
                        {{ moment(item.created_at).format("DD MMM, YYYY") }}
                      </span>
                    </div>
                    <div
                      class="col-4 px-0 pt-4 m-0 info_short_leatesd text-end"
                      v-if="!item.draft_behave"
                    >
                      <span
                        @click="deleteButtonClick(item)"
                        style="color: rgb(231 37 8); cursor: pointer"
                        >Delete job</span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 p-0 sidbar_ch_new3" v-if="detail1">
                <div class="col-lg-12 pr-0 pt-4 pl-0">
                  <div class="col-md-12 row m-0 p-0">
                    <div
                      class="col-md-12 row m-0 border-t-lr-16 bg-info-new p-4"
                    >
                      <div class="col-md-12 p-0 text-end">
                        <button
                          class="badge badge-danger badge-pill"
                          @click="(detail1 = false), (alwyes = true)"
                        >
                          X
                        </button>
                      </div>
                      <div
                        class="col-md-4 p-0 margin_nagtive mb-4"
                        style="position: relative"
                      >
                        <img
                          src="/images/job_page/approved.svg"
                          alt="job stutas"
                        />
                      </div>

                      <div class="col-md-12 p-0">
                        <h4
                          class="mb-0"
                          style="
                            color: #242424;
                            font-size: 18px;
                            font-weight: bold;
                          "
                        >
                          {{ detail1.job_title }}
                        </h4>
                      </div>
                      <div class="col-md-12 p-0 mt-2">
                        <h4
                          class="
                            widget-title
                            tooltipch
                            mb-0
                            bold
                            detail_heading
                          "
                        >
                          <img
                            src="/images/job_page/Money_left.svg"
                            alt="..."
                            class="pr-2"
                          /><span class="tooltiptextch">Per month salary</span>
                        </h4>
                        <span
                          v-if="
                            detail1.salary_min != NULL &&
                            detail1.salary_market_competitive != 1 &&
                            detail1.salary_depends_on_exp != 1
                          "
                          >{{ detail1.salary_min }} -
                          {{ detail1.salary_max }}</span
                        >
                        <span v-if="detail1.salary_market_competitive == 1">
                          Salary market competitive</span
                        >
                        <span v-if="detail1.salary_depends_on_exp == 1">
                          Salary depends on exp</span
                        >
                        <span
                          v-if="
                            detail1.salary_min == NULL &&
                            detail1.salary_market_competitive != 1 &&
                            detail1.salary_depends_on_exp != 1
                          "
                        >
                          Not add</span
                        >
                      </div>
                      <div class="col-md-12 p-0">
                        <div class="m-0" style="color: #666; font-size: 14px">
                          <h4
                            class="
                              widget-title
                              tooltipch
                              mb-0
                              mt-3
                              bold
                              detail_heading
                            "
                          >
                            <img
                              src="/images/job_page/Due_date.svg"
                              alt="..."
                              class="pr-2 mr-3"
                            /><span class="tooltiptextch">Expiry Date</span>
                          </h4>
                          <span>{{
                            moment(detail1.apply_by).format("DD MMM, YYYY")
                          }}</span>
                        </div>
                      </div>
                      <div class="col-md-12 p-0 pb-2">
                        <div class="m-0" style="color: #666; font-size: 14px">
                          <h4
                            class="
                              widget-title
                              tooltipch
                              mb-0
                              mt-3
                              bold
                              detail_heading
                            "
                          >
                            <img
                              src="/images/job_page/Location_left.svg"
                              alt="..."
                              class="pr-2"
                            /><span class="tooltiptextch">Job Location</span>
                          </h4>
                          <p
                            v-if="detail1.location_city"
                            class="col col-md-3 text-primary mb-0 detail_body"
                            style="display: contents"
                          >
                            <span
                              v-for="(_item, _index) in detail1 &&
                              detail1.location_city"
                              :key="_index"
                              style="display: inline-flex"
                            >
                              <span
                                v-if="
                                  _index > 0 &&
                                  _index < detail1.location_city.length
                                "
                                style=""
                                >&nbsp;,&nbsp;</span
                              >
                              {{ _item }}
                            </span>
                          </p>
                          <span class="pl-4" v-if="detail1.location_city == ''"
                            >Not add</span
                          >
                          <!-- </div> -->
                        </div>
                      </div>
                      <hr
                        class="col-md-12 p-0 mt-3"
                        style="background: rgba(53, 162, 229, 0.25)"
                      />
                      <div
                        class="
                          grid_button_by_job_add_details_1st
                          _btn_gridddd
                          p-0
                          m-0
                        "
                      >
                        <a
                          class="p-0"
                          target="_blank"
                          :href="job_link(detail1)"
                        >
                          <button
                            type="button"
                            class="new_details_job_dashbord_list2 back_fill_job"
                          >
                            <span class="v-btn__content">View Job Post </span>
                          </button>
                        </a>
                        <div class="p-0" style="">
                          <button
                            type="button"
                            class="new_details_job_dashbord_list2"
                          >
                            <a
                              @contextmenu="handler($event)"
                              @click="editButtonClick(detail1.id)"
                            >
                              <span class="v-btn__content"
                                >Edit Job</span
                              >
                            </a>
                          </button>
                        </div>
                      </div>
                      <div
                        class="
                          grid_button_by_job_add_details_2nd
                          _btn_gridddd
                          p-0
                          m-0
                        "
                      >
                        <div class="p-0" style="">
                          <button
                            type="button"
                            class="new_details_job_dashbord_list2"
                          >
                            <a
                              target="blank"
                              :href="
                                '/recruiter/job-applications?' + detail1.id
                              "
                            >
                              <span class="v-btn__content"
                                >View Applicants</span
                              >
                            </a>
                          </button>
                        </div>
                        <div class="p-0" style="">
                          <button
                            type="button"
                            class="new_details_job_dashbord_list2"
                          >
                            <a target="blank" href="#">
                              <span class="v-btn__content">Job Stats</span>
                            </a>
                          </button>
                        </div>
                        <div class="p-0" @click="jobArchive(detail1)">
                          <button
                            type="button"
                            class="new_details_job_dashbord_list2 archive_buton"
                          >
                            <img
                              class="dashbord"
                              src="\images/job_page/archive.png"
                              alt=""
                              width="16"
                              height="16"
                            />
                          </button>
                        </div>
                        <div class="p-0" v-if="!detail1.draft_behave">
                          <button
                            @click="deleteButtonClick(detail1)"
                            type="button"
                            class="new_details_job_dashbord_list2"
                            style="
                              background: rgba(147, 6, 6, 0.05) !important;
                              border-color: rgba(147, 6, 6, 0.5) !important;
                              padding: 0px !important;
                              margin-right: 10px;
                            "
                          >
                            <img
                              class="dashbord"
                              src="\images/job_application/Delete.svg"
                              alt=""
                              width="16"
                              height="16"
                            />
                          </button>
                        </div>
                      </div>
                      <hr
                        class="col-md-12 p-0 mt-3"
                        style="background: rgba(53, 162, 229, 0.25)"
                      />
                      <div class="col-md-12 p-0">
                        <h4
                          class="mb-4"
                          style="
                            color: #005696;
                            font-size: 20px;
                            font-weight: bold;
                          "
                        >
                          Application Details:
                        </h4>
                      </div>
                      <div class="col-md-12 p-0 mt-2">
                        <h4
                          class="mb-2"
                          style="
                            color: #000000;
                            font-size: 14px;
                            font-weight: bold;
                          "
                        >
                          Job Function:
                        </h4>
                        <p
                          v-if="
                            detail1.require_skills &&
                            detail1.require_skills.jobFunction
                          "
                          class="col col-md-3 text-primary mb-0 detail_body"
                          style="display: contents"
                        >
                          <span
                            v-for="(_item, _index) in detail1.require_skills"
                            :key="_index"
                            style="
                              display: inline-flex;
                              color: #6a6464;
                              font-size: 14px;
                            "
                          >
                            <span
                              v-if="
                                _index > 0 &&
                                _index < detail1.require_skills.length
                              "
                              style=""
                              >&nbsp;,&nbsp;</span
                            >
                            {{ _item.jobFunction.job_function_name }}
                          </span>
                        </p>
                        <p
                          v-if="!detail1.require_skills.jobFunction"
                          class="col col-md-3 text-primary mb-0 detail_body"
                          style="display: contents"
                        >
                          Not add Job Function
                        </p>
                      </div>
                      <hr
                        class="col-md-12 p-0 mt-3"
                        style="background: #000000b3"
                      />
                      <div class="col-md-4 p-0 mt-2">
                        <h4
                          class="mb-2"
                          style="
                            color: #000000;
                            font-size: 14px;
                            font-weight: bold;
                          "
                        >
                          Job Type:
                        </h4>
                        <p
                          v-if="detail1.job_shift"
                          class="col col-md-3 text-primary mb-0 detail_body"
                          style="display: contents"
                        >
                          <span
                            v-for="(_item, _index) in detail1.job_shift"
                            :key="_index"
                            style="
                              display: inline-flex;
                              color: #6a6464;
                              font-size: 14px;
                            "
                          >
                            <span
                              v-if="
                                _index > 0 && _index < detail1.job_shift.length
                              "
                              style=""
                              >&nbsp;,&nbsp;</span
                            >
                            {{ _item }}
                          </span>
                        </p>
                        <p
                          v-if="!detail1.job_shift"
                          class="col col-md-3 text-primary mb-0 detail_body"
                          style="display: contents"
                        >
                          Not Add
                        </p>
                        <div class="verticalhr"></div>
                      </div>
                      <div class="col-md-4 p-0 mt-2">
                        <h4
                          class="mb-2"
                          style="
                            color: #000000;
                            font-size: 14px;
                            font-weight: bold;
                          "
                        >
                          Gender:
                        </h4>
                        <p
                          class="col col-md-3 text-primary mb-0 detail_body"
                          style="display: contents"
                        >
                          <span
                            v-for="(_item, _index) in detail1.gender"
                            :key="_index"
                            style="
                              display: inline-flex;
                              color: #6a6464;
                              font-size: 14px;
                            "
                          >
                            <span
                              v-if="
                                _index > 0 && _index < detail1.gender.length
                              "
                              style=""
                              >&nbsp;,&nbsp;</span
                            >
                            {{ _item }}
                          </span>
                          <span
                            v-if="!detail1.gender"
                            style="
                              display: inline-flex;
                              color: #6a6464;
                              font-size: 14px;
                            "
                          >
                            No preference
                          </span>
                        </p>
                        <div class="verticalhr"></div>
                      </div>
                      <div class="col-md-4 p-0 mt-2">
                        <h4
                          class="mb-2"
                          style="
                            color: #000000;
                            font-size: 14px;
                            font-weight: bold;
                          "
                        >
                          Positions:
                        </h4>
                        <p
                          v-if="detail1.no_of_vacancies"
                          class="col col-md-3 text-primary mb-0 detail_body"
                          style="display: contents"
                        >
                          <span
                            style="
                              display: inline-flex;
                              color: #6a6464;
                              font-size: 14px;
                            "
                          >
                            {{ detail1.no_of_vacancies }}
                          </span>
                        </p>
                        <p
                          v-if="!detail1.no_of_vacancies"
                          class="col col-md-3 text-primary mb-0 detail_body"
                          style="display: contents"
                        >
                          <span
                            style="
                              display: inline-flex;
                              color: #6a6464;
                              font-size: 14px;
                            "
                          >
                            Not add
                          </span>
                        </p>
                      </div>
                      <hr
                        class="col-md-12 p-0 mt-3"
                        style="background: #000000b3"
                      />
                      <div class="col-md-6 p-0 mt-2">
                        <h4
                          class="mb-2"
                          style="
                            color: #000000;
                            font-size: 14px;
                            font-weight: bold;
                          "
                        >
                          Education:
                        </h4>
                        <p
                          v-if="detail1.education"
                          class="col col-md-3 text-primary mb-0 detail_body"
                          style="display: contents"
                        >
                          <span
                            v-if="detail1.education"
                            style="
                              display: inline-flex;
                              color: #6a6464;
                              font-size: 14px;
                            "
                          >
                            {{ detail1 && detail1.education }}
                          </span>
                        </p>
                        <span v-if="!detail1.education">Not add </span>
                        <div class="verticalhr"></div>
                      </div>
                      <div class="col-md-6 p-0 mt-2">
                        <h4
                          class="mb-2"
                          style="
                            color: #000000;
                            font-size: 14px;
                            font-weight: bold;
                          "
                        >
                          Experience:
                        </h4>
                        <p
                          class="col col-md-3 text-primary mb-0 detail_body"
                          style="display: contents"
                        >
                          <span
                            v-for="(_item, _index) in detail1.experience"
                            :key="_index"
                            style="
                              display: inline-flex;
                              color: #6a6464;
                              font-size: 14px;
                            "
                          >
                            <span
                              v-if="
                                _index > 0 && _index < detail1.experience.length
                              "
                              style=""
                              >&nbsp;,&nbsp;</span
                            >
                            {{ _item }}
                          </span>
                          <span
                            v-if="!detail1.experience"
                            style="
                              display: inline-flex;
                              color: #6a6464;
                              font-size: 14px;
                            "
                          >
                            No preference
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-4 p-0 alwyes" v-if="alwyes">
                <div class="col-lg-12 pl-0 pr-0 pt-4">
                  <div class="card sidebar">
                    <div class="card-body widget cardbodych" style="">
                      <h5
                        class=""
                        style="
                          font-style: normal;
                          font-weight: 700 !important;
                          font-size: 30px;
                          line-height: 120%;
                          color: #005696;
                        "
                      >
          Advertise with  <br />
          job4u.pk
          </h5>
        </div>
        <div class="col-12">
          <p
            style="
                        font-style: normal;
                        font-weight: 400;
                        font-size: 18px;
                        line-height: 140%;
                        color: #666666;
                        background: transparent !important;
                      "
          >
          Contact us to display your
          Ad here to reach tens of
          thousands of people!

          </p>
                      <button
                        style="
                          padding: 12px 16px;
                          gap: 8px;
                          background: #35a2e5;
                          border-radius: 53px;
                          font-style: normal;
                          font-weight: 400;
                          font-size: 16px;
                          line-height: 140%;
                          color: #ffffff;
                        "
                      >
                      <img
              class="dashbord123"
              src="\images/job_application/Call.svg"
              alt=""
              style="margin-right: 10px"
            />
              Contact Sales
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <v-form ref="form" v-if="createForm" v-model="valid" lazy-validation>
          <v-text-field
            v-model="city"
            :rules="nameRules"
            label="City name"
            required
          ></v-text-field>
          <b-form-select
            v-model="state_id"
            :options="statesOptions"
            size="sm"
            class="mt-3"
          ></b-form-select>
          <div style="margin-top: 5%">
            <v-btn
              class="
                btn btn-sm btn-success
                font-weight-bold
                py-2
                px-3 px-xxl-5
                my-1
              "
              @click="createCity"
            >
              Save
            </v-btn>
            <v-btn
              style="margin-left: 6%"
              class="
                btn btn-sm btn-danger
                font-weight-bold
                py-2
                px-3 px-xxl-5
                my-1
              "
              @click="cancel"
            >
              Cancel
            </v-btn>
          </div>
        </v-form>

        <v-form ref="form" v-if="updateForm" v-model="valid" lazy-validation>
          <v-text-field
            v-model="city"
            :rules="nameRules"
            label="City name"
            required
          ></v-text-field>
          <b-form-select
            v-model="state_id"
            :options="statesOptions"
            size="sm"
            class="mt-3"
          ></b-form-select>
          <div style="margin-top: 5%">
            <v-btn
              class="
                btn btn-sm btn-success
                font-weight-bold
                py-2
                px-3 px-xxl-5
                my-1
              "
              @click="updateCity"
            >
              Update
            </v-btn>
            <v-btn
              style="margin-left: 6%"
              class="
                btn btn-sm btn-danger
                font-weight-bold
                py-2
                px-3 px-xxl-5
                my-1
              "
              @click="cancel"
            >
              Cancel
            </v-btn>
          </div>
        </v-form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_URL } from "@/core/api";
import Swal from "sweetalert2";
import moment from "moment";
import IndexService from "@/MainServices/IndexService.js";

export default {
  data() {
    return {
      search: "",
      cities: [],
      loading: true,
      success: false,
      token: `Bearer ${localStorage.getItem("token")}`,
      valid: true,
      jobs: [],
      originalData: [],
      createForm: false,
      updateForm: false,
      city: "",
      city_id: null,
      state_id: null,
      job_title_filter: null,
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => (v && v.length <= 10) || "Name must be less than 10 characters",
      ],
      headers: [
        { text: "Job Title", value: "job_title" },
        { text: "City", value: "location_city" },
        { text: "SALARY RANGE", value: "salary_range" },
        // { text: "Job Type", value: "job_type" },
        // { text: "Job Function", value: "job_function" },
        { text: "Experience", value: "experience" },
        { text: "Education", value: "education" },
        // { text: "Gender", value: "gender" },
        { text: "No. of Vacancies", value: "no_of_vacancies" },
        { text: "Expiry date", value: "apply_by" },
        { text: "Action", value: "action" },
      ],
      data: [],
      detail1: null,
      alwyes: true,
    };
  },
  mounted() {
    var link = !!document.querySelector("link[rel='canonical']")
      ? document.querySelector("link[rel='canonical']")
      : document.createElement("link");
    link.setAttribute("rel", "canonical");
    link.setAttribute(
      "href",
      location.protocol + "//" + location.host + location.pathname
    );
    document.head.appendChild(link);
    this.fetch();
    this.fetchStates();
    // IndexService.getCities().then((res) => {
    //     res.data.map((el) => {
    //       this.cities.push({
    //         id: el.id,
    //         value: el.city_name,
    //       });
    //     });
    //   });
  },
  methods: {
    handler: function (e) {
      //do stuff
      e.preventDefault();
    },
    moment: function (date) {
      return moment(date);
    },
    cancel() {
      this.createForm = false;
      this.updateForm = false;
      this.city = "";
      this.state_id = null;
    },
    createFormEnable() {
      this.$router.push({ name: "recruiter-job-create" });
    },
    editButtonClick(id) {
      // let cities = [];
      // this.cities.map((el) => {
      //   cities.push(el.value);
      // });
      // localStorage.setItem("city_local", this.cities);
      this.data.forEach((element) => {
        if (element.id == id) {
          localStorage.setItem("job_edit_obj", JSON.stringify(element));
          this.$router.push({ name: "recruiter-job-edit" });
        }
      });
    },
    job_link(item) {
      let routeData = this.$router.resolve({
        path:
          "/jobs-careers/pakistan/" +
          item.location_city.map((v) => v.toLowerCase()).join("-") +
          "/" +
          item.job_title
            .toLowerCase()
            .replace(/ /g, "-")
            .replace(/[^\w-]+/g, "") +
          "/" +
          item.id,
        // params: {
        //   search_text: this.search_text,
        //   selected_cities: [{ id: 1, value: item }],
        // },
      });
      return routeData.href;
    },
    myFunc(item) {
      // console.log(item);
      if (item.text != "All") {
        const id = item.value;
        var temp = [];
        this.data = this.originalData;
        this.data.forEach((element) => {
          if (element.id == id) {
            temp.push(element);
          }
        });
        this.job_title_filter = item.text;
        this.data = temp;
      } else {
        this.job_title_filter = null;
        this.data = this.originalData;
      }
    },
    ClearFilter() {
      this.job_title_filter = null;
      this.data = this.originalData;
    },
    fetch() {
      axios.defaults.headers.common["Authorization"] = this.token;
      axios
        .get(`${API_URL}/jobs`)
        .then((res) => {
          res.data.forEach((element) => {
            this.jobs.push({
              value: element.id,
              text: element.job_title,
            });
          });
          this.jobs.unshift(...[{ value: "All", text: "All" }]);
          this.originalData = res.data;
          this.data = res.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    fetchStates() {
      axios.defaults.headers.common["Authorization"] = this.token;
      axios
        .get(`${API_URL}/states`)
        .then((res) => {
          res.data.forEach((element) => {
            this.statesOptions.push({
              value: element.id,
              text: element.state_name,
            });
          });
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    createCity() {
      if ((this.city == "", this.state_id == null)) {
        Swal.fire({
          title: "",
          text: "Please, provide correct data!",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
        return;
      }
      axios.defaults.headers.common["Authorization"] = this.token;
      axios
        .post(`${API_URL}/cities`, {
          state_id: this.state_id,
          city_name: this.city,
        })
        .then((res) => {
          this.loading = false;
          this.success = true;
          this.city = "";
          Swal.fire({
            title: "",
            text: "City added",
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          this.fetch();
        })
        .catch(() => {
          this.loading = false;
          Swal.fire({
            title: "",
            text: "Something went wrong!",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
        });
    },
    updateCity() {
      if ((this.city == "", this.state_id == null)) {
        Swal.fire({
          title: "",
          text: "Please, provide correct data!",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
        return;
      }
      axios.defaults.headers.common["Authorization"] = this.token;
      axios
        .put(`${API_URL}/cities/${this.city_id}`, {
          state_id: this.state_id,
          city_name: this.city,
        })
        .then((res) => {
          this.loading = false;
          this.success = true;
          (this.city = ""), (this.state_id = null);
          Swal.fire({
            title: "",
            text: "City updated",
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          this.fetch();
          this.cancel();
        })
        .catch(() => {
          this.loading = false;
          Swal.fire({
            title: "",
            text: "Something went wrong!",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
        });
    },

    deleteButtonClick(item) {
      axios.defaults.headers.common["Authorization"] = this.token;
      axios
        .get(`${API_URL}/job-destroy/${item.id}`)
        .then((res) => {
          Swal.fire({
            title: "",
            text: "Application has been deleted",
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          this.fetch();
          this.loading = false;
        })
        .catch(() => {
          Swal.fire({
            title: "",
            text: "Something went wrong!",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          this.loading = false;
        });
      this.detail1 = false;
      this.alwyes = true;
    },

    changeBlockStatus(item) {
      axios.defaults.headers.common["Authorization"] = this.token;
      axios
        .get(`${API_URL}/job-block/${item.id}`)
        .then((res) => {
          Swal.fire({
            title: "",
            text: "Job has been updated",
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          this.fetch();
        })
        .catch(() => {
          this.loading = false;
          Swal.fire({
            title: "",
            text: "Something went wrong!",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
        });
    },
    changeStatus(item) {
      axios.defaults.headers.common["Authorization"] = this.token;
      axios
        .get(`${API_URL}/job-status/${item.id}`)
        .then((res) => {
          Swal.fire({
            title: "",
            text: "Job has been updated",
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          this.fetch();
        })
        .catch(() => {
          this.loading = false;
          Swal.fire({
            title: "",
            text: "Something went wrong!",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
        });
    },
    jobArchive(item) {
      axios.defaults.headers.common["Authorization"] = this.token;
      axios
        .get(`${API_URL}/job-archive/${item.id}`)
        .then((res) => {
          Swal.fire({
            title: "",
            text: "Job has been updated",
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          this.fetch();
    this.fetchStates();
        })
        .catch(() => {
          this.loading = false;
          Swal.fire({
            title: "",
            text: "Something went wrong!",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
        });
    },
    singleDetail1(item) {
      this.detail1 = item;
      this.alwyes = false;
    },
    onImageLoadFailure(event) {
      event.target.src = "../images/profile_ch.jpg";
    },
  },
};
</script>
<style>
.container {
  max-width: none !important;
}
</style>